/**
 * Created by Allan on 2021/11/17.
 * Contact 84880528@qq.com.
 * 文字格式为数字
 */
export default function(value){
    if(!value) return;
    return Number(value)
}



// WEBPACK FOOTER //
// ./src/filter/txtNumber.js